module.exports = __webpack_public_path__ + "static/media/Q3_Front_Right.8d380183.png";